module.exports = __webpack_public_path__ + "static/individualan-168a8f7588f38c5d97fc1043b8ba97cf.svg";